<template>
  <div class="header-content">
    <div class="header-text">
      {{title}}
    </div>
    <div class="header-right">
      <el-dropdown>
        <span>
          {{$store.state.user.info.name}}<i class="el-icon-arrow-down el-icon--right"></i>
        </span>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item icon="el-icon-user" @click.native="$router.push('/system/user/edit/'+$store.state.user.info.id)">个人信息</el-dropdown-item>
          <el-dropdown-item icon="el-icon-lock" @click.native="$router.push('/system/user/changePwd/'+$store.state.user.info.id)">修改密码</el-dropdown-item>
          <el-dropdown-item icon="fa fa-power-off" @click.native="handleLoginOut">退出登陆</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      //配置标题名
      title: process.env.VUE_APP_TITLE
    };
  },
  methods: {
    /**
     * 退出登陆
     */
    handleLoginOut() {
      // 清空用户信息
      this.$dyform.dispose("login", 'loginOut',{'uid':this.$store.state.user.info.id,'loginName':this.$store.state.user.info.loginName}).then( response => {
        //console.log(response)
      }).catch(function (error) {
        console.log(error)
      })
      this.$store.commit("set", ["user.info", {}]);
      this.$store.commit("save", ["user.token", ""]);
      
      // 跳转到登陆页
      this.$router.push("/login");
    }
  }
};
</script>
<style>
.header-content {
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
}
.header-content .header-text {
  flex: 1;
  padding: 0px 20px;
  font-size: 18px;
}
.header-content .header-right {
  padding: 0px 20px;
}
.header-content .el-dropdown {
  color: #fff;
  cursor: pointer;
  outline: none;
  font-size: 16px;
}
</style>